import { jsx as _jsx } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
/** A Landscape is a lens, never a grant: membership is read through the viewer's own access. */ export function AccessNote() {
    return /*#__PURE__*/ _jsx("p", {
        className: "text-sm text-muted-foreground",
        "data-testid": Testids.landscapes.accessNote,
        children: "A Landscape only groups opportunities for planning. It does not grant access to anything; you see the opportunities your own permissions already allow."
    });
}
